import { Button } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";

import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";
import React from "react";
import { SHOPIFY_URL } from "../../utils/shopify.utils";

const MenuItem = ({ element, closeDrawer }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <div
        style={{
          lineHeight: "0.9rem",
        }}
      >
        {/*<Link to={SHOPIFY_URL + `pages${element.route}`} style={{ textDecoration: "none" }}>*/}
          <Button
            className={"evrbed-menu-item"}
            variant="text"
            sx={{
              color: theme.COLORS.WHITE.backgroundWhite,
              textDecoration: "none",
              fontSize: "1rem",
              fontFamily: "noto-sans",
              textTransform: "none",
              marginLeft: "1.5rem",
              // pointerEvents: "none",
              "&hover": { background: "transparent", opacity: 1 },
            }}
            onClick={() => {
              closeDrawer();
              window.top.location.href = SHOPIFY_URL + `pages${element.route}`;
              // navigate(element.route);
            }}
          >
            {t(element.title)}
          </Button>
        {/*</Link>*/}
      </div>
    </>
  );
};

export default MenuItem;
